/**
 * Created by m.igrachev on 7/6/2017.
 */
const documentedProperties = [
    {
        name: "children",
        type: "React.Children",
        defaultValue: "n/a",
        isRequired: "true",
        description:
            "ControlMessages component nests ControlMessageGroups, so some children are expected."
    },
    {
        name: "extraClasses",
        type: "String",
        defaultValue: "n/a",
        isRequired: "false",
        description: "Extra css classes to be applied to the ControlMessages container."
    },
    {
        name: "theme",
        type: '["light", "dark", "accent"]',
        defaultValue: "light",
        isRequired: "false",
        description: "Visualization style of the Control Messages."
    },
    {
        name: "visualizationLayer",
        type: '["normal", "onTop", "modal"]',
        defaultValue: "normal",
        isRequired: "false",
        description: "The visualization layer of the Control Messages."
    },
    {
        name: "bigIcons",
        type: "Boolean",
        defaultValue: "false",
        isRequired: "false",
        description: "If set to true will advice Control Message Groups to use big icons."
    },
    {
        name: "modalSize",
        type: "['s', 'm', 'l']",
        defaultValue: "m",
        isRequired: "false",
        description: "Defines the size of the control messages if they are of type modal."
    },
    {
        name: "acceptLabel",
        type: "String",
        defaultValue: "n/a",
        isRequired: "false",
        description:
            "Defines the label of the Accept button of Control Messages that can be accepted."
    },
    {
        name: "closeLabel",
        type: "String",
        defaultValue: "n/a",
        isRequired: "false",
        description:
            "Defines the label of the Close button of Control Messages that can be accepted."
    },
    {
        name: "onClose",
        type: "String",
        defaultValue: "n/a",
        isRequired: "false",
        description: "A callback to be called when Control Messages are closed."
    },
    {
        name: "onAccept",
        type: "String",
        defaultValue: "n/a",
        isRequired: "false",
        description:
            "A callback to be called when Control Messages are accepted. if Provided, will also mark the component as acceptable"
    }
];

export default documentedProperties;
